module.exports = __webpack_public_path__ + "img/public/languageIcon.svg?6e2fc605";